// === FRISIA WORKFLOW CONFIGURATION ===
// Customer-specific workflow steps for Frisia/Glider
// Order: Product Selection -> Client Info -> AVP -> Inboedel -> Woonhuis -> Summary

import { WorkflowNavigationConfig, WorkflowStep } from '@sluitstraat/core';

export const FRISIA_WORKFLOW_STEPS: WorkflowStep[] = [
  {
    id: 'product-selection',
    name: 'Productkeuze',
    route: '/workflow/product-selection',
    type: 'universal',
  },
  {
    id: 'client-information',
    name: 'Persoonlijke gegevens',
    route: '/workflow/client-information',
    type: 'universal',
  },
  {
    id: 'aansprakelijkheid',
    name: 'Aansprakelijkheid',
    route: '/workflow/aansprakelijkheid',
    type: 'product',
    productId: 'aansprakelijkheid',
  },
  {
    id: 'inboedel',
    name: 'Inboedel',
    route: '/workflow/inboedel',
    type: 'product',
    productId: 'inboedel',
  },
  {
    id: 'woonhuis',
    name: 'Woonhuis',
    route: '/workflow/woonhuis',
    type: 'product',
    productId: 'woonhuis',
  },
  {
    id: 'summary',
    name: 'Overzicht',
    route: '/workflow/summary',
    type: 'universal',
  },
];

export const FRISIA_APPLICATION_STEPS: WorkflowStep[] = [
  {
    id: 'payment-information',
    name: 'Betaalgegevens',
    route: '/workflow/payment-information',
    type: 'universal',
  },
  {
    id: 'acceptance-questions',
    name: 'Acceptatievragen',
    route: '/workflow/acceptance-questions',
    type: 'universal',
  },
  {
    id: 'confirmation',
    name: 'Bevestiging',
    route: '/workflow/confirmation',
    type: 'universal',
  },
];

export const frisiaWorkflowConfig: WorkflowNavigationConfig = {
  steps: FRISIA_WORKFLOW_STEPS,
  applicationSteps: FRISIA_APPLICATION_STEPS,
};
